import {createContext, useContext} from 'react'

interface InputContext {
  cursorRef: React.RefObject<HTMLSpanElement>
  inputFocused: boolean
  inputKeyDown: React.KeyboardEventHandler<Element>
  inputOnChange: React.ChangeEventHandler<Element>
  inputOnFocus: React.FocusEventHandler<Element>
  inputOnBlur: React.FocusEventHandler<Element>
  inputRef: React.RefObject<HTMLInputElement>
  inputSelectionEnd: number
  inputSelectionStart: number
  shouldShowSpinner: boolean
  updateStyledInputBlockCount: (count: number) => void
  suspendFocus: (element: HTMLElement) => void
  updateInputSelection: (selectionStart: number, selectionEnd?: number) => void
}

export const InputContext = createContext<InputContext | undefined>(undefined)

export const useInput = () => {
  const context = useContext(InputContext)
  if (!context) {
    throw new Error('useInput must be used inside a InputContext')
  }

  return context
}

try{ InputContext.displayName ||= 'InputContext' } catch {}